import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=44a64178&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports